<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openDialog = true">
                <v-list-tile-content>
                  <v-list-tile-title>IMPORT EXCEL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile
                @click="
                  printAllOperationSettingList('printAllOperationSettingList')
                "
              >
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllOperationSetting()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="operationTypes"
                label="Operation Type"
                v-model="queryParams.operationType"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.auto"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="operationSettingList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.operationType }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                <v-icon v-if="props.item.auto == true" medium color="green"
                  >check_circle</v-icon
                >
                <v-icon v-else medium color="red">cancel</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!--print all layout setting-->
    <div
      id="printAllOperationSettingList"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center; padding-bottom: 5px">
        <p style="font-size: 15px; margin: 0px">Operation Settings</p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <th style="border: 1px solid black; text-align: center">Code</th>
            <th style="border: 1px solid black; text-align: center">Name</th>
            <th style="border: 1px solid black; text-align: center">
              Descriptin
            </th>
            <th style="border: 1px solid black; text-align: center">
              Operation Type
            </th>
            <th style="border: 1px solid black; text-align: center">Is Auto</th>
            <th style="border: 1px solid black; text-align: center">
              Debit Code
            </th>
            <th style="border: 1px solid black; text-align: center">
              Debit Account Name
            </th>
            <th style="border: 1px solid black; text-align: center">
              Credit Code
            </th>
            <th style="border: 1px solid black; text-align: center">
              Credit Account Name
            </th>
          </thead>
          <tbody style="border: 1px solid black">
            <tr v-for="(item, index) in allOperationSettingList" :key="index">
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                {{ item.code }}
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                {{ item.name }}
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                {{ item.description }}
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                {{ item.operationType }}
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                <span v-if="item.auto == true">TRUE</span
                ><span v-if="item.auto == false">FALSE</span>
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                <div
                  style="height: 4rem"
                  v-for="(accountDetail, detail) in item.debitAccountList"
                  :key="detail"
                >
                  {{ accountDetail.code }}
                </div>
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                <div
                  style="height: 4rem"
                  v-for="(accountDetail, detail) in item.debitAccountList"
                  :key="detail"
                >
                  {{ accountDetail.accountName }}
                </div>
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                <div
                  style="height: 4rem"
                  v-for="(accountDetail, detail) in item.creditAccountList"
                  :key="detail"
                >
                  {{ accountDetail.code }}
                </div>
              </td>
              <td
                valign="top"
                style="border: 1px solid black; text-align: left"
              >
                <div
                  style="height: 4rem"
                  v-for="(accountDetail, detail) in item.creditAccountList"
                  :key="detail"
                >
                  {{ accountDetail.accountName }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- dialog -->
    <operationSettingExcel
      :isOpen="openDialog"
      v-on:change="dialogClose()"
    ></operationSettingExcel>
  </v-container>
</template>
<script>
import { commonService } from "../../services/common-service";
import { operationSettingService } from "../../services/operation-setting-service";
import operationSettingExcel from "../../components/operation-setting/OperationSettingExcel.vue";

export default {
  name: "OperationSettingList",
  components: { operationSettingExcel },
  data: () => ({
    buttonLoading: false,
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Operation Setting",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Code", align: "left", value: "code" },
      { text: "Name", value: "name" },
      { text: "Description", value: "description" },
      { text: "Operation Type", value: "operationType" },
      { text: "Updated Date", value: "createdDate" },
      { text: "Updated By", value: "createdBy" },
      { text: "Is Auto", value: "auto" },
    ],
    statusList: [
      { label: "ALL", value: "" },
      { label: "Auto", value: true },
      { label: "Manual", value: false },
    ],
    operationTypes: [],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    operationSettingList: [],
    totalRows: 0,

    queryParams: {
      name: "",
      code: "",
      operationType: "",
      auto: "",
    },
    allOperationSettingList: [],
    openDialog: false,
  }),
  watch: {
    pagination: {
      handler() {
        this.getOperationSettingList();
      },
      deep: true,
    },
  },

  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.operationType) {
      this.queryParams.operationType = this.$route.query.operationType;
    }
    if (this.$route.query.auto) {
      this.queryParams.auto = this.$route.query.auto;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getOperationSettingList();
    this.getAllOperationSettingType();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "operation-settings",
        query: this.queryParams,
      });
      this.getOperationSettingList();
    },
    getAllOperationSettingType() {
      operationSettingService
        .getOperationSettingTypes()
        .then((res) => {
          if (res.data) {
            this.operationTypes = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getOperationSettingList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      operationSettingService
        .getOperationSettingList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.operationSettingList = res.data.operationSettingList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/operation-setting/new");
    },
    onEdit(operationSetting) {
      // go to details page
      this.$router.push("/operation-setting/" + operationSetting.id);
    },
    exportAllOperationSetting() {
      this.buttonLoading = true;
      operationSettingService
        .getOperationSettingExcelExport(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    printAllOperationSettingList(divName) {
      this.buttonLoading = true;
      operationSettingService
        .getAllOperationSettingList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allOperationSettingList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
    dialogClose() {
      this.openDialog = false;
      this.getOperationSettingList();
    },
  },
};
</script>